/**
 * DateTime 格式正则为:
 * /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/
 * DateTime("2019-04-02T14:35:12.420Z")
 */
import Declaration, { DeclarationFactory } from './base';



// 判断是否为正确的日期格式
export function isAcceptableDateTime(v: string) {
  return /^(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})(\+|\-)(\d{2})\:(\d{2})$/.test(v);
}


class DateTimeDeclaration extends Declaration implements DeclarationFactory {
  public declaration = 'DateTime';

  public generateRegExp() {
    return /^(DateTime\(\"((\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})(\+|\-)(\d{2})\:(\d{2}))\"\))/;
  }

  public match(input: string) {
    const matched = input.match(/^(DateTime\(([^)]*)\))/);

    if (matched) {
      const datetimeString = matched[2].slice(1, matched[2].length - 1);

      // Number.isNaN(Date.parse(datetimeString))
      // 判断时间值是否正确（eg. '2019-04-30T15:01:03+30:00' 是个错误的时间值 ）
      if (isAcceptableDateTime(datetimeString) && !Number.isNaN(Date.parse(datetimeString))) {
        return {
          type: 'DateTime',
          declaration: this.declaration,
          raw: matched[1],
          value: matched[2],
          isAtom: true,
          isDeclaration: true
        };
      } else {
        throw this.generateInvalidError(matched[1], matched[2], 'DateTime 类型值的格式必须为 `DateTime("2019-04-25T10:39:59+08:00")`');
      }
    }
  }
}

export default new DateTimeDeclaration();
